import React from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash/debounce';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { matchMedia, defaultLayout } from 'core/layout';
import { DEFAULT_THEME, THEME_MODES, DEAULT_THEME_MODE } from './constants';
import { ThemeReset } from './ThemeReset';

class ThemeProvider extends React.PureComponent {
  static propTypes = {
    mode: PropTypes.oneOf(THEME_MODES),
  };

  static defaultProps = {
    mode: DEAULT_THEME_MODE,
  };

  static childContextTypes = {
    hasThemeProvider: PropTypes.bool,
  };

  constructor(props) {
    super(props);

    const themeState = this._buildThemeState(props.mode);
    this.state = Object.assign({}, themeState, {
      layout: defaultLayout
    });

    this._handleResize = debounce(this._onResize, 200);
    this._headerHeight = 65;
  }

  getChildContext() {
    return {
      hasThemeProvider: true,
    };
  }

  componentDidMount() {
    if (window) {
      window.addEventListener('resize', this._handleResize);
      this._handleResize();
    }
  }

  componentWillUnmount() {
    if (window) {
      window.removeEventListener('resize', this._handleResize);
    }
  }

  componentWillReceiveProps(newProps) {
    if (newProps.mode !== this.props.mode) {
      const newThemeState = this._buildThemeState(newProps.mode);
      this.setState(prevState => Object.assign({}, prevState, newThemeState));
    }
  }

  _buildThemeState = (mode) => ({
    theme: {[DEFAULT_THEME]: {mode}}
  })

  // NOTE: Context nedarbojas, kā vēlētos.. jāizmanto cits mehānisms, kas izpilda konkrēto vajadzību
  _onResize = (event) => {
    const windowWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    const bp = matchMedia(windowWidth);
    if (bp && bp !== this.state.layout) {
      this.setState(prevState => Object.assign({}, prevState, {
        layout: bp
      }));
    }
  }

  render() {
    const {children} = this.props;
    return (
      <StyledThemeProvider theme={this.state.theme}>
        <ThemeReset data-query-id='js-content-container'>
          {children}
        </ThemeReset>
      </StyledThemeProvider>
    );
  }
}

export default ThemeProvider;



// WEBPACK FOOTER //
// ./src/core/theme/ThemeProvider.js